import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Duplicate icon for cloning/duplicating items
 */
export const DuplicateIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </Icon>
  );
};

export default DuplicateIcon;
